import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    apiRoot: ENV.API_ROOT,
};

export { config as homeConfig } from './home';
export { config as menuConfig } from './menu-side-nav';
export { config as welcomeConfig } from './welcome';
export { config as oldPagesConfig } from './old-pages';
export { config as productsConfig } from './products';
export { config as pointProductsConfig } from './point-products';
export { config as orderNew } from './order-new';
export { config as orderChangePrice } from './order-change-price';
export { config as designPageConfig } from './design-page';
export { config as designTemplateConfig } from './design-template';
export { config as categoryConfig } from './category';
export { config as attributeConfig } from './attribute';
export { config as reportsConfig } from './reports';
export { config as liveProductConfig } from './live-product';
export { config as liveRoomConfig } from './live-room';
export { config as liveRoomsListConfig } from './live-rooms-list';
export { config as presaleStockConfig } from './presale-stock';
export { config as changeSku } from './changeSku';
export { config as orderPrint } from './orderPrint';
export { config as presellOrder } from './presellOrder';
export { config as displayLocation } from './display-location';
export { config as blackListConfig } from './black-list';
export { config as shippingOrder } from './shippingOrder';
export { config as deliveryOrder } from './deliveryOrder';
export { config as liveWechatDataConfig } from './live-wechat-data';
export { config as sunbathingOrder } from './sunbathingOrder';
export { config as labelRule } from './label-rule';
export { config as extendLabelRule } from './extend-label-rule';
export { config as synonym } from './synonym';
export { config as batchDetailConfig } from './batch-detail-config';
export { config as shelfRule } from './shelf-rule';
